
              import chai from 'chai/chai.js';
              var version = chai.version;
var AssertionError = chai.AssertionError;
var use = chai.use;
var util = chai.util;
var config = chai.config;
var Assertion = chai.Assertion;
var expect = chai.expect;
var should = chai.should;
var Should = chai.Should;
var assert = chai.assert;
              export { version, AssertionError, use, util, config, Assertion, expect, should, Should, assert };
              export default chai;